import src from "IMAGE";
export default { src, width: 742, height: 336, blurWidth: 0, blurHeight: 0};
